import { TemplateData } from './htmlTemplates';

export const techFuturisticTemplate = {
  id: 'tech-futuristic',
  name: '科技未来',
  description: '未来科技风格，适合科技和创新内容',
  category: 'technology',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: linear-gradient(135deg, #0f0f23, #1a1a2e, #16213e);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', monospace;
          position: relative;
          overflow: hidden;
        }

        .tech-grid {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: 
            linear-gradient(rgba(0, 255, 255, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 255, 255, 0.1) 1px, transparent 1px);
          background-size: 20px 20px;
          animation: gridMove 20s linear infinite;
        }

        @keyframes gridMove {
          0% { transform: translate(0, 0); }
          100% { transform: translate(20px, 20px); }
        }

        .brand-tech {
          position: absolute;
          top: 25px;
          right: 25px;
          font-size: 14px;
          color: #00ffff;
          font-weight: bold;
          z-index: 3;
          text-shadow: 0 0 10px #00ffff;
        }

        .title {
          font-size: 42px;
          font-weight: 900;
          color: #ffffff;
          text-align: center;
          line-height: 1.1;
          margin-bottom: 30px;
          letter-spacing: 2px;
          position: relative;
          z-index: 2;
          text-transform: uppercase;
        }

        .title-tech {
          background: linear-gradient(45deg, #00ffff, ${data.theme.primaryColor});
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          position: relative;
          text-shadow: 0 0 20px #00ffff50;
        }

        .title-tech::before {
          content: '';
          position: absolute;
          top: 0;
          left: -5px;
          right: -5px;
          bottom: 0;
          background: linear-gradient(90deg, transparent, #00ffff20, transparent);
          animation: scan 3s ease-in-out infinite;
        }

        @keyframes scan {
          0%, 100% { transform: translateX(-100%); }
          50% { transform: translateX(100%); }
        }

        .subtitle {
          font-size: 14px;
          color: #b0b0b0;
          text-align: center;
          line-height: 1.5;
          font-weight: 300;
          position: relative;
          z-index: 2;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .tech-highlight {
          background: linear-gradient(45deg, #00ffff, ${data.theme.accentColor});
          color: #0f0f23;
          padding: 2px 6px;
          border-radius: 2px;
          font-weight: 700;
          margin: 0 2px;
          box-shadow: 0 0 10px #00ffff50;
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 0 10px #00ffff50;
          }
          50% {
            box-shadow: 0 0 20px #00ffff80, 0 0 30px #00ffff40;
          }
        }

        .circuit-line {
          position: absolute;
          background: #00ffff;
          box-shadow: 0 0 5px #00ffff;
        }

        .line-1 {
          top: 100px;
          left: 50px;
          width: 100px;
          height: 2px;
          animation: circuitFlow 4s ease-in-out infinite;
        }

        .line-2 {
          bottom: 150px;
          right: 60px;
          width: 2px;
          height: 80px;
          animation: circuitFlow 4s ease-in-out infinite 1s;
        }

        .line-3 {
          top: 50%;
          left: 30px;
          width: 60px;
          height: 2px;
          transform: translateY(-50%) rotate(45deg);
          animation: circuitFlow 4s ease-in-out infinite 2s;
        }

        @keyframes circuitFlow {
          0%, 100% {
            opacity: 0.3;
            box-shadow: 0 0 5px #00ffff;
          }
          50% {
            opacity: 1;
            box-shadow: 0 0 15px #00ffff, 0 0 25px #00ffff50;
          }
        }

        .tech-node {
          position: absolute;
          width: 8px;
          height: 8px;
          background: #00ffff;
          border-radius: 50%;
          box-shadow: 0 0 10px #00ffff;
          animation: nodeGlow 3s ease-in-out infinite;
        }

        .node-1 {
          top: 120px;
          left: 80px;
        }

        .node-2 {
          bottom: 180px;
          right: 90px;
        }

        .node-3 {
          top: 60%;
          left: 60px;
        }

        @keyframes nodeGlow {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 10px #00ffff;
          }
          50% {
            transform: scale(1.5);
            box-shadow: 0 0 20px #00ffff, 0 0 30px #00ffff50;
          }
        }

        .data-stream {
          position: absolute;
          bottom: 60px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 10px;
          color: #00ffff;
          letter-spacing: 2px;
          opacity: 0.7;
          animation: dataFlow 5s linear infinite;
        }

        @keyframes dataFlow {
          0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
          50% { opacity: 0.7; transform: translateX(-50%) translateY(0); }
          100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="tech-grid"></div>
        <div class="brand-tech">${data.theme.logo}</div>
        
        <div class="circuit-line line-1"></div>
        <div class="circuit-line line-2"></div>
        <div class="circuit-line line-3"></div>
        
        <div class="tech-node node-1"></div>
        <div class="tech-node node-2"></div>
        <div class="tech-node node-3"></div>
        
        <h1 class="title">
          ${data.title.split(' ').map((word, i) => 
            i % 2 === 1 ? `<span class="title-tech">${word}</span>` : word
          ).join(' ')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{2,5})/g, '<span class="tech-highlight">$1</span>')}</p>
        
        <div class="data-stream">DATA STREAM ACTIVE</div>
      </div>
    </body>
    </html>
  `
};
